module.exports = __webpack_public_path__ + "img/toggle-example.98a3dea3.svg";